import React, { useState, createContext, useMemo, useCallback } from 'react'
import Component from './Component'
import { CollectionType, StoryType } from '../../lib/types'

// @ts-ignore
export const StepInviteRecorderContext = createContext<{
  actions: {
    open: (collection: CollectionType | null, story?: StoryType) => void
    close: () => void
  }
}>({
  // @ts-ignore
  actions: {}
})

export const StepInviteRecorderProvider: React.FC = ({ children }) => {
  const [stepStoryUpload, setStepInviteRecorder] = useState<boolean>(false)
  const [collection, setCollection] = useState<CollectionType | null>(null)
  const [story, setStory] = useState<StoryType | null>(null)

  const open = useCallback((collection: CollectionType | null, story?: StoryType) => {
    setStepInviteRecorder(true)
    setCollection(collection)
    setStory(story || null)
  }, [])

  const close = useCallback(() => {
    setStepInviteRecorder(false)
  }, [])

  const value = useMemo(
    () => ({
      actions: { open, close }
    }),
    [open, close]
  )

  return (
    <StepInviteRecorderContext.Provider value={value}>
      {stepStoryUpload && <Component initialCollection={collection} initialStory={story} />}
      {children}
    </StepInviteRecorderContext.Provider>
  )
}
